module.exports = __webpack_public_path__ + "static/media/user.35c0d598.svg";